// Libs
import React, { useState, useEffect } from 'react';

// Own Libs
import * as ui from '@digital/ui';

//Api
import { CrfCicloOrcamentarioRelatorio } from '@app/api/crf/crfRelatorioCicloOrcamentario';
import { getCrfFechamentoControleRfaByFechamentoId } from '@app/api/crf/crffechamento';

//Files
import TableBuilUp from '../Dashboard/Buildup/TableBuilUp';

//Utils

interface IFechamentoControleRfaProps {
    fechamentoId: string;
}

const FechamentoControleRfa = ({ fechamentoId }: IFechamentoControleRfaProps) => {
    const [cicloOrcamentarioRelatorioTotal, setCicloOrcamentarioRelatorioTotal] = useState<CrfCicloOrcamentarioRelatorio>();

    useEffect(() => {
        if (fechamentoId) {
            getCrfFechamentoControleRfaByFechamentoId(fechamentoId).then((result) => {
                setCicloOrcamentarioRelatorioTotal(result);
            });
        }
    }, [fechamentoId]);

    return (

        <ui.GridView noform>
            <ui.Widget
                title="RESULTADO"
                span={12}
                actions={[]}>
                {cicloOrcamentarioRelatorioTotal ? (
                    <TableBuilUp
                        cicloOrcamentarioRelatorioTotal={cicloOrcamentarioRelatorioTotal}
                        paginacaoConfig={{ pageSize: 10 }}
                        relatorioControleRfa={true}
                        ocultarColunaDetalhe={true}
                    />
                ) :
                    (
                        <>
                        </>
                    )
                }
            </ui.Widget>
        </ui.GridView>

    );

}

export default FechamentoControleRfa;